import gql from "graphql-tag";

export const getEmailTemplates = gql`
    query GetEmailTemplates {
        communication{
            allUnlayerTemplates{
                totalCount
                nodes{
                    id
                    parentID
                    isFolder
                    templateName
                    dateModified
                }
            }
        }
    }
`;
